import { Button, Modal, ModalBody, ModalFooter, Paragraph } from '@customerio/pluma-components/react';

type CancelImportModalProps = {
  isOpen: boolean;
  isCanceling: boolean;
  onConfirm: () => void;
  onClose: () => void;
};

/** Confirms stopping a run that is still moving; what already landed stays. */
export function CancelImportModal({ isOpen, isCanceling, onConfirm, onClose }: CancelImportModalProps) {
  return (
    <Modal isOpen={isOpen} title="Cancel import?" onClose={onClose} data-test-cancel-sql-import-row-modal>
      <ModalBody>
        <Paragraph mb="200">
          Canceling this import is immediate and cannot be undone. People who have already been added or updated will
          remain in the workspace.
        </Paragraph>
        <Paragraph>
          Note: This action will only cancel this run. To stop future syncs, select Pause sync or Delete sync from the
          Sync Settings.
        </Paragraph>
      </ModalBody>
      <ModalFooter>
        <Button variant="secondary" onClick={onClose} data-test-cancel-sql-import-row-modal-cancel-button>
          Cancel
        </Button>
        <Button isCritical isLoading={isCanceling} onClick={onConfirm} data-test-cancel-sql-import-cancel-import-button>
          Yes, cancel import
        </Button>
      </ModalFooter>
    </Modal>
  );
}
